module.exports = __webpack_public_path__ + "img/energizing-menu.ac1b9217.png";